<template>
  <div class="rounded-lg border border-gray-200 overflow-hidden bg-white">
    <div class="flex justify-between items-center p-6">
      <h2 class="text-lg font-semibold text-gray-900">Notifications</h2>
      <div class="flex gap-2">
        <Button v-if="shouldShowReply" variant="outline" @click="disputeResponse()">
          <Reply class="h-4 w-4" />
        </Button>
      </div>
    </div>
    <div class="border-t border-gray-200">
      <table class="w-full table-auto text-sm text-left">
        <thead class="bg-grey-light-100 text-grey-light-600 font-medium border-b border-gray-200">
          <tr>
            <th class="px-4 py-2">Date</th>
            <th class="px-4 py-2">Name</th>
            <th class="px-4 py-2">Reason</th>
            <th class="px-4 py-2">Details</th>
            <th></th>
          </tr>
        </thead>
        <tbody class="text-grey-light-600">
          <tr v-for="(notification, index) in notifications" :key="index" class="border-b border-gray-200">
            <td class="p-5">{{ displayDateTime(notification.date) }}</td>
            <td class="p-5">{{ notification.name }}</td>
            <td class="p-5">{{ notification.reason }}</td>
            <td class="p-5">{{ notification.details }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <DisputeResponseModal
      :order="props.order!"
      :show="showDisputeResponseModal"
      @update:show="showDisputeResponseModal = false"
    />
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { useUserStore } from '@/stores/users';
import { displayDateTime } from '@/utils/format.utils';
import { Reply } from 'lucide-vue-next';
import { computed, ref } from 'vue';
import type { ModelNote, ModelOrderResponse } from '@layup/api-sdk';
import DisputeResponseModal from '../dispute-response-modal/DisputeResponseModal.vue';

const props = defineProps<{
  notifications: ModelNote[] | undefined;
  order: ModelOrderResponse | null | undefined;
}>();

const userStore = useUserStore();
const showDisputeResponseModal = ref<boolean>(false);

const shouldShowReply = computed(() => {
  if (
    props.notifications &&
    userStore.user.merchantRole === 'ADMIN' &&
    props.order?.state === 'PLACED' &&
    props.order?.orderCancellationRequest === 'DISPUTE' &&
    // Only show reply when cancellation terms are defined. Dynamic cancellation terms are not supported.
    props.order?.cancellationTerms?.definition?.length === 1
  ) {
    for (const notification of props.notifications) {
      if (notification.read === false && notification.change === 'DISPUTE' && notification.type === 'CANCELLATION') {
        return true;
      }
    }
  }
  return false;
});

const disputeResponse = () => {
  showDisputeResponseModal.value = true;
};
</script>
